export default __webpack_public_path__ + "static/media/G0680.34I-26417_-18486_0.1666267620000.369cf946.jpg";